module.exports = __webpack_public_path__ + "static/media/HCMM558.151c3ab8.jpg";